(function() {
  function initCustomNavigation() {
    // Wait for jQuery to be available
    if (typeof jQuery === 'undefined' && typeof window.jQuery === 'undefined') {
      setTimeout(initCustomNavigation, 100);
      return;
    }
    
    var $ = window.jQuery || jQuery;
    
    if (!$) {
      setTimeout(initCustomNavigation, 100);
      return;
    }
    
    $(document).ready(function(){
      var $header = $('.header-section .header, .header-section header').first();
      var $headerSection = $('.header-section');
      
      // Function to enforce z-index on header elements (prevent Shopify override)
      function enforceHeaderZIndex() {
        var headerZIndex = "10000";
        
        // Apply to header-section and all header-sticky elements - always enforce
        $(".header-section").each(function() {
          var $el = $(this);
          $el.css("z-index", headerZIndex);
          this.style.setProperty("z-index", headerZIndex, "important");
        });
        
        $(".header-sticky, .header-section.header-sticky").each(function() {
          var $el = $(this);
          $el.css("z-index", headerZIndex);
          this.style.setProperty("z-index", headerZIndex, "important");
        });
        
        // Apply to header elements inside header-section
        $(".header-section .header, .header-section header").each(function() {
          var $el = $(this);
          $el.css("z-index", headerZIndex);
          this.style.setProperty("z-index", headerZIndex, "important");
        });
        
        // Apply to header-navigation-wrapper
        $(".header-navigation-wrapper").each(function() {
          var $el = $(this);
          $el.css("z-index", headerZIndex);
          this.style.setProperty("z-index", headerZIndex, "important");
        });
        
        // Also apply to any Shopify-specific header selectors
        $("#shopify-section-header, [id^='shopify-section-header']").each(function() {
          this.style.setProperty("z-index", headerZIndex, "important");
        });
        
        $(".shopify-section-header-sticky").each(function() {
          this.style.setProperty("z-index", headerZIndex, "important");
        });
      }
      
      // Watch for style changes on header elements using MutationObserver
      function watchHeaderZIndex() {
        var headerElements = document.querySelectorAll('.header-section, .header-sticky, .header-section .header, .header-section header');
        
        headerElements.forEach(function(element) {
          if (window.MutationObserver) {
            var observer = new MutationObserver(function(mutations) {
              mutations.forEach(function(mutation) {
                if (mutation.type === 'attributes' && (mutation.attributeName === 'style' || mutation.attributeName === 'class')) {
                  // Always enforce z-index when style or class changes
                  element.style.setProperty("z-index", "10000", "important");
                }
              });
            });
            
            observer.observe(element, {
              attributes: true,
              attributeFilter: ['style', 'class']
            });
          }
        });
      }
      
      // Enforce z-index immediately and periodically
      enforceHeaderZIndex();
      watchHeaderZIndex();
      
      // Re-enforce after theme.js might have run
      setTimeout(enforceHeaderZIndex, 100);
      setTimeout(enforceHeaderZIndex, 500);
      setTimeout(enforceHeaderZIndex, 1000);
      
      // Re-enforce on scroll (in case theme.js changes it)
      $(window).on('scroll', function() {
        enforceHeaderZIndex();
      });
      
      // Re-enforce on resize
      $(window).on('resize', function() {
        setTimeout(enforceHeaderZIndex, 50);
      });
      
      function updateNavContainerPosition() {
        // Enforce z-index first to prevent Shopify override
        enforceHeaderZIndex();
        
        // Position dropdown slightly up and behind the header
        if ($header.length && $header.is(':visible')) {
          var headerRect = $header[0].getBoundingClientRect();
          var headerSection = $header.closest('.header-section');
          
          // Force header z-index to 10000 with !important via style tag if needed
          // Ensure header has high z-index to be above nav-container (force with inline style)
          var headerZIndex = "10000";
          $header.css({
            "z-index": headerZIndex,
            "position": "relative"
          });
          $header[0].style.setProperty("z-index", headerZIndex, "important");
          
          if (headerSection.length) {
            headerSection.css("z-index", headerZIndex);
            headerSection[0].style.setProperty("z-index", headerZIndex, "important");
          }
          
          // Also set on header-navigation-wrapper if it exists
          $(".header-navigation-wrapper").each(function() {
            $(this).css("z-index", headerZIndex);
            this.style.setProperty("z-index", headerZIndex, "important");
          });
          $(".header-section").each(function() {
            $(this).css("z-index", headerZIndex);
            this.style.setProperty("z-index", headerZIndex, "important");
          });
          
          // Get bottom position relative to viewport
          // Since nav-container is position: fixed, use viewport coordinates directly
          var headerBottom = headerRect.bottom;
          
          // Get header element's actual width and position (the white rounded box)
          var headerLeft = headerRect.left;
          var headerWidth = headerRect.width;
          
          // Position dropdown 10px up from header bottom (behind header) with matching width
          // Force z-index: 1 with inline style - MUST be lower than header z-index
          var navZIndex = "1";
          $(".nav-bar-open").css("z-index", navZIndex);
          $(".nav-container").css({
            "top": (headerBottom - 10) + "px",
            "left": headerLeft + "px",
            "right": "auto",
            "width": headerWidth + "px",
            "z-index": navZIndex,
            "position": "fixed"
          });
        }
      }
      
      // Update on scroll
      $(window).scroll(function() {
        updateNavContainerPosition();
      });
      
      // Update on load and resize - with delay to ensure DOM is ready
      setTimeout(function() {
        updateNavContainerPosition();
      }, 200);
      
      $(window).on('resize', function() {
        setTimeout(function() {
          updateNavContainerPosition();
        }, 100);
      });
      
      // Also run after a short delay to catch any late-loading elements
      setTimeout(function() {
        updateNavContainerPosition();
      }, 500);
      
  // Close dropdown when mouse leaves
  $(".nav-container").mouseleave(function () {
      $(this).removeClass("active");
      $(".header__menu .nav-item, .navbar-nav.main-categories .nav-item").removeClass("active");
  });
  
  // Header navigation hover - show dropdown
  $(".header__menu .navbar-nav.main-categories .nav-item, .navbar-nav.main-categories .nav-item").hover(function () {
      var uId = $(this).data("uid");
      if (uId) {
          // Calculate and set dropdown position FIRST
          updateNavContainerPosition();
          
          // Show dropdown
          $(".nav-container").addClass("active");
          $(".header__menu .nav-item, .navbar-nav.main-categories .nav-item").removeClass("active");
          $(this).addClass("active");
          
          // Update position again after dropdown is shown
          setTimeout(function() {
              updateNavContainerPosition();
          }, 10);
          
          // Switch to the correct category
          $(".product-box .type1").removeClass("active");
          $(".product-list .product-series").removeClass("active");
          $(".product-box .type1[data-uid='" + uId + "']").addClass("active");
          $(".product-box .type1[data-uid='" + uId + "']").find(".product-list .product-series:first-child").addClass("active");
          
          // Set first cateNavItem as active
          $(".product-box .type1[data-uid='" + uId + "'] .cateNav .cateNavItem").removeClass("active");
          $(".product-box .type1[data-uid='" + uId + "'] .cateNav .cateNavItem:first-child").addClass("active");
          
          // Final position update
          setTimeout(function() {
              updateNavContainerPosition();
          }, 50);
      }
  }, function() {
      // Don't hide on mouseout - let nav-container mouseleave handle it
  });
  
  // Old type-box hover (keeping for compatibility)
  $(".type-box .type-item").hover(function () {
     $(".type-box .type-item").removeClass("active");
     $(".product-list .product-series").removeClass("active")
     $(this).addClass("active");
     var uId = $(this).data("uid");
     $(".product-box .type1").each(function () {
        var typeUid = $(this).data("uid"); 
        if (uId == typeUid) {
            $(this).addClass("active"); 
            $(this).find(".product-list .product-series:first-child").addClass("active");
        } else {
            $(this).removeClass("active"); 
        }
    });
  });
  $(".cateNav .cateNavItem").hover(function () {
     $(".cateNav .cateNavItem").removeClass("active");
     $(this).addClass("active");
     var Id = $(this).data("id");
     $(".product-list .product-series").each(function () {
        var typeId = $(this).data("id");
        if (Id == typeId) {
            $(this).addClass("active");
        } else {
            $(this).removeClass("active");
        }
    });
  });
  // Handle clicks on the plus/minus sign (right side) to toggle menu
  $(".menu-link .right").click(function (e) {
    e.preventDefault();
    e.stopPropagation();
    var $currentMenuItem = $(this).closest(".menu-item");
    if ($currentMenuItem.hasClass("isActive")) {
        $currentMenuItem.removeClass("isActive");
        $currentMenuItem.find(".menu-wrapper").slideUp();
    } else {
        $(".menu-item").removeClass("isActive");
        $currentMenuItem.addClass("isActive");
        $currentMenuItem.find(".menu-wrapper").slideDown();
    }
    return false;
  });
  
  // Handle clicks on the entire menu-link area (but not on links)
  $(".menu-link").click(function (e) {
    // If clicking on a link, allow navigation
    if ($(e.target).is('a') || $(e.target).closest('a').length) {
      return true; // Allow navigation
    }
    // If clicking on the right side, it's already handled above
    if ($(e.target).closest('.right').length) {
      return false;
    }
    // Otherwise, toggle the menu
    e.preventDefault();
    e.stopPropagation();
    var $currentMenuItem = $(this).closest(".menu-item");
    if ($currentMenuItem.hasClass("isActive")) {
        $currentMenuItem.removeClass("isActive");
        $currentMenuItem.find(".menu-wrapper").slideUp();
    } else {
        $(".menu-item").removeClass("isActive");
        $currentMenuItem.addClass("isActive");
        $currentMenuItem.find(".menu-wrapper").slideDown();
    }
    return false;
  });
  
  // Handle sub-menu title clicks
  $(".menu-wrapper .title").click(function (e) {
    e.preventDefault();
    e.stopPropagation();
    var $currentLevel = $(this).closest(".level");
    if ($currentLevel.hasClass("isAct")) {
        $currentLevel.removeClass("isAct");
        $currentLevel.find(".level1_box").slideUp();
    } else {
        $(".level").removeClass("isAct");
        $currentLevel.addClass("isAct");
        $currentLevel.find(".level1_box").slideDown();
    }
    return false;
  });
  
  // Allow direct link clicks on menu names - navigate normally
  $(".menu-link .menu-name a, .menu-link .left a").click(function (e) {
    // Allow navigation - don't prevent default
    e.stopPropagation(); // But stop propagation to prevent menu toggle
  });
  $(".list-item[data-index='2']").click(function(){
    $("body").addClass("menu_open");
  })
    });
  }
  
  // Start initialization
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCustomNavigation);
  } else {
    initCustomNavigation();
  }
})();